var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStateNoSections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.5005 193C79.0005 154.5 155.001 58.5718 181.001 40.0004C237.001 0.000875473 220.788 116.101 201.501 182C183.501 243.5 80.0005 231.5 79.5005 193Z",
    fill: "url(#paint0_linear_37241_230223)",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195 64.0002C154 39.9207 77.9999 34.8183 51.9999 55.5001C32.4999 71.0115 30.4612 101.188 42.9999 139.5C52.0001 167 82.3342 192.087 126 197.5C186.5 205 227.334 196.245 236.5 167C247 133.5 241 91.0161 195 64.0002Z",
    fill: "url(#paint1_linear_37241_230223)",
    fillOpacity: 0.07
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.667 75.75H76.3333C74.9066 75.75 73.75 76.9066 73.75 78.3333V93.8333C73.75 95.2601 74.9066 96.4167 76.3333 96.4167H179.667C181.093 96.4167 182.25 95.2601 182.25 93.8333V78.3333C182.25 76.9066 181.093 75.75 179.667 75.75ZM76.3333 68C70.6264 68 66 72.6264 66 78.3333V93.8333C66 99.5403 70.6264 104.167 76.3333 104.167H179.667C185.374 104.167 190 99.5403 190 93.8333V78.3333C190 72.6264 185.374 68 179.667 68H76.3333Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.667 117.083H76.3333C74.9066 117.083 73.75 118.24 73.75 119.667V135.167C73.75 136.593 74.9066 137.75 76.3333 137.75H179.667C181.093 137.75 182.25 136.593 182.25 135.167V119.667C182.25 118.24 181.093 117.083 179.667 117.083ZM76.3333 109.333C70.6264 109.333 66 113.96 66 119.667V135.167C66 140.874 70.6264 145.5 76.3333 145.5H179.667C185.374 145.5 190 140.874 190 135.167V119.667C190 113.96 185.374 109.333 179.667 109.333H76.3333Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.667 158.417H76.3333C74.9066 158.417 73.75 159.573 73.75 161V176.5C73.75 177.927 74.9066 179.083 76.3333 179.083H179.667C181.093 179.083 182.25 177.927 182.25 176.5V161C182.25 159.573 181.093 158.417 179.667 158.417ZM76.3333 150.667C70.6264 150.667 66 155.293 66 161V176.5C66 182.207 70.6264 186.833 76.3333 186.833H179.667C185.374 186.833 190 182.207 190 176.5V161C190 155.293 185.374 150.667 179.667 150.667H76.3333Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8534 85.4978C58.2423 88.9638 56.3992 97.17 54.8257 106.986C50.2699 135.405 22.3667 118.076 24.0753 99.3609C25.2686 86.2897 32.693 81.1884 46.8534 85.4978Z",
    fill: "url(#paint2_linear_37241_230223)",
    fillOpacity: 0.15
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.376,
    cy: 14.5563,
    rx: 9.8332,
    ry: 11.8536,
    transform: "rotate(20.6101 212.376 14.5563)",
    fill: "url(#paint3_linear_37241_230223)",
    fillOpacity: 0.15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37241_230223",
    x1: 144.515,
    y1: 214.77,
    x2: 36.8117,
    y2: 65.0139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_37241_230223",
    x1: 130.7,
    y1: 191.706,
    x2: 66.9779,
    y2: 31.9173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_37241_230223",
    x1: 38.8602,
    y1: 119.987,
    x2: 18.8597,
    y2: 87.6737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_37241_230223",
    x1: 211.676,
    y1: 25.1543,
    x2: 199.115,
    y2: 5.16337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateNoSections);
export default __webpack_public_path__ + "static/media/emptyStateNoSections.fef3f919.svg";
export { ForwardRef as ReactComponent };